import React from "react";

const DashboardAlertSVG = ({ className }) => {
  return (
    <svg
      width="104"
      height="104"
      viewBox="0 0 104 104"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clip-path="url(#clip0_4838_36911)">
        <path
          d="M60.024 73.125H9.14063C4.10028 73.125 0 69.0247 0 63.9844C0 62.4252 0.401781 60.9345 1.19316 59.5479L31.644 4.73688C33.2418 1.82102 36.2976 0 39.6094 0C42.9211 0 45.9769 1.82102 47.5837 4.75191L76.7016 57.0783C77.1629 57.9085 77.2105 58.9083 76.8326 59.777C76.4518 60.6489 75.687 61.2946 74.7646 61.5207C69.5784 62.7912 65.0973 66.4777 62.7794 71.3814C62.2735 72.4466 61.2024 73.125 60.024 73.125Z"
          fill="#FFDF40"
        />
        <path
          d="M60.024 73.125C61.2024 73.125 62.2735 72.4466 62.7792 71.3814C65.0971 66.4777 69.5782 62.7912 74.7644 61.5207C75.6868 61.2946 76.4516 60.6489 76.8324 59.777C77.2103 58.9083 77.1627 57.9085 76.7014 57.0783L47.5837 4.75191C45.9769 1.82102 42.9211 0 39.6094 0V73.125H60.024Z"
          fill="#FFBE40"
        />
        <path
          d="M39.6094 42.6562C37.9253 42.6562 36.5625 41.2935 36.5625 39.6094V27.4219C36.5625 25.7378 37.9253 24.375 39.6094 24.375C41.2935 24.375 42.6562 25.7378 42.6562 27.4219V39.6094C42.6562 41.2935 41.2935 42.6562 39.6094 42.6562Z"
          fill="#4D4D80"
        />
        <path
          d="M39.6094 54.8438C41.2921 54.8438 42.6562 53.4796 42.6562 51.7969C42.6562 50.1141 41.2921 48.75 39.6094 48.75C37.9266 48.75 36.5625 50.1141 36.5625 51.7969C36.5625 53.4796 37.9266 54.8438 39.6094 54.8438Z"
          fill="#4D4D80"
        />
        <path
          d="M79.625 104C93.0869 104 104 93.0869 104 79.625C104 66.1631 93.0869 55.25 79.625 55.25C66.1631 55.25 55.25 66.1631 55.25 79.625C55.25 93.0869 66.1631 104 79.625 104Z"
          fill="var(--bs-primary-200)"
        />
        <path
          d="M104 79.625C104 66.1629 93.0871 55.25 79.625 55.25V104C93.0871 104 104 93.0871 104 79.625Z"
          fill="var(--bs-primary-700)"
        />
        <path
          d="M79.625 97.9062C89.7215 97.9062 97.9062 89.7215 97.9062 79.625C97.9062 69.5285 89.7215 61.3438 79.625 61.3438C69.5285 61.3438 61.3438 69.5285 61.3438 79.625C61.3438 89.7215 69.5285 97.9062 79.625 97.9062Z"
          fill="#F3F5F9"
        />
        <path
          d="M97.9062 79.625C97.9062 69.5441 89.7059 61.3438 79.625 61.3438V97.9062C89.7059 97.9062 97.9062 89.7059 97.9062 79.625Z"
          fill="#E1E6F0"
        />
        <path
          d="M88.7656 82.6719H79.625C77.9409 82.6719 76.5781 81.3091 76.5781 79.625V70.4844C76.5781 68.8003 77.9409 67.4375 79.625 67.4375C81.3091 67.4375 82.6719 68.8003 82.6719 70.4844V76.5781H88.7656C90.4497 76.5781 91.8125 77.9409 91.8125 79.625C91.8125 81.3091 90.4497 82.6719 88.7656 82.6719Z"
          fill="#4D4D80"
        />
        <path
          d="M88.7656 82.6719C90.4497 82.6719 91.8125 81.3091 91.8125 79.625C91.8125 77.9409 90.4497 76.5781 88.7656 76.5781H82.6719V70.4844C82.6719 68.8003 81.3091 67.4375 79.625 67.4375V82.6719H88.7656Z"
          fill="#443D66"
        />
        <path
          d="M42.6562 51.7969C42.6562 50.1142 41.2921 48.75 39.6094 48.75V54.8438C41.2921 54.8438 42.6562 53.4796 42.6562 51.7969Z"
          fill="#443D66"
        />
        <path
          d="M42.6562 39.6094V27.4219C42.6562 25.7378 41.2935 24.375 39.6094 24.375V42.6562C41.2935 42.6562 42.6562 41.2935 42.6562 39.6094Z"
          fill="#443D66"
        />
      </g>
      <defs>
        <clipPath id="clip0_4838_36911">
          <rect width="104" height="104" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default DashboardAlertSVG;
